import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { TrafficByAffiliateTileComponent } from './traffic-by-affiliate-tile.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), SharedModule],
  declarations: [TrafficByAffiliateTileComponent],
  exports: [TrafficByAffiliateTileComponent]
})
export class TrafficByAffiliateTileModule {}
